// src/router/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ component: Component }) => {
  const isAuthenticated = !!localStorage.getItem("userAccess");

  return isAuthenticated ? <Component /> : <Navigate to="/login" replace />;
};

const PublicRoute = ({ component: Component }) => {
  const isAuthenticated = !!localStorage.getItem("userAccess");

  return isAuthenticated ? <Navigate to="/home" replace /> : <Component />;
};

export { PrivateRoute, PublicRoute };
